import { request } from '@/shared/api/request'
export const sendAidXml = (data) => request({ url: `/contract/aid/send`, method: 'POST', data })
